<template>
  <NotFound v-if="props.notFound" renderType="songNotFound"></NotFound>
  <div v-else class="detailWrapper" :class="`${isFromApp && 'fromApp'}`">
    <div class="closeBtn" v-if="!isFromApp" @click="() => $emit('close')">
      <i />
    </div>
    <div class="musicInfo">
      <!-- <img
        class="logo"
        v-if="$$language() === 'en' && isFromShare && !isLogin"
        src="@/assets/img/player/logo.webp"
      />
      <img
        class="logo"
        v-else-if="isFromShare && !isLogin"
        src="@/assets/img/land/cnlogo.png"
      /> -->
      <div>
        <img
          v-if="coverUrl"
          :src="getObjectStorageFullUrl(coverUrl)"
          alt=""
          class="cover-img"
        />
        <img
          v-else
          src="@/assets/img/store/defaultCover.png"
          alt=""
          class="cover-img"
        />
      </div>
      <div class="flex title-status-info">
        <h1 class="title olh">{{ props.title }}</h1>

        <div class="musicInfo-status">
          <div
            class="musicInfo-model-status"
            v-if="data?.model"
            :class="data?.model?.split(' ').pop()"
          >
            {{ data?.model?.split(" ").pop() }}
          </div>

          <div
            class="musicInfo-publish-status"
            v-if="[1, 3].includes(data.publish_state) && isSelf"
          >
            <div class="musicInfo-publish-status-text">
              {{ $t("create.published") }}
            </div>
            <div class="musicInfo-publish-status-border"></div>
          </div>
          <img class="publish-icon" src="@/assets/img/store/published.webp" />
          <div
            class="musicInfo-edit-upload-status"
            v-if="isSelf && data.is_generated_from_uploaded_file"
          >
            {{ $$t("editor.uploaded") }}
          </div>
          <div
            class="musicInfo-edit-type-status"
            v-if="isSelf && getEditorType(data)"
          >
            {{ getEditorType(data) }}
          </div>

          <!-- <div class="musicInfo-edit-type-status" v-if="data.is_trimmed">
          {{ $$t("editor.trim") }}
        </div> -->
        </div>
      </div>
      <div class="tag tag-tag-box olh">
        <span class="rotate-loading block" v-if="props.isGenerating"> </span>
        <span v-if="!props.isGenerating && !data?.description">
          {{ combineStrings(data?.genres, data?.moods) }}
        </span>
        <span class="olh block" v-if="!props.isGenerating && data?.description?.trim()">
          {{ data?.description }}
        </span>
      </div>
      <div class="author olh flex">
        <img class="avatar" v-if="avatar" :src="avatar" />
        <span class="avatarName">{{ name }}</span>
      </div>
      <div class="gen-date">
        <span class="fn-inline" v-if="data?.publish_at">
          {{ formatDate(data?.publish_at * 1000, "YYYY-MM-DD") }}｜
        </span>
        <span class="fn-inline" v-if="!data?.publish_at && data?.generate_at">
          {{ formatDate(data?.generate_at * 1000, "YYYY-MM-DD hh:mm") }}｜
        </span>
        <i v-if="data?.play_count" class="ico play-count fn-inline"></i>
        <span v-if="data?.play_count" class="fn-inline play-count-num">
          {{ formatNumberRound(data?.play_count) }}｜
        </span>
        <span class="fn-inline">
          {{
            props.isGenerating
              ? "--:--"
              : mediaUtil.formatTime(data?.duration_milliseconds / 1000)
          }}
        </span>
      </div>
      <div
        ref="lyricBlockRef"
        @touchstart="handleScroll"
        @touchmove="handleScroll"
        @touchend="handleScroll"
        class="lyricBlock"
      >
        <div
          v-if="segments"
          @scroll="handleScroll"
          class="lyrics height100-scroll"
        >
          <template v-for="(item, index) in formattedSegments" :key="index">
            <div class="line-wrapper" v-if="tools.isProd()">
              <div class="line" :class="[item.type] + '--mobile'">
                {{ item.text }}
              </div>
              <div class="line-mask" v-if="currentLine === index">
                {{ item.text }}
              </div>
            </div>
            <div class="line-wrapper" v-else>
              <div class="line" :class="[item.type] + '--mobile'">
                {{ item.text + `    ${item.start}__${item.end}` }}
              </div>
              <div class="line-mask" v-if="currentLine === index">
                {{ item.text + `    ${item.start}__${item.end}` }}
              </div>
            </div>
          </template>
        </div>
        <div v-else class="lyrics height100-scroll">
          <template
            v-for="(item, index) in formatSegments(lyrics)"
            :key="index"
          >
            <div class="line-wrapper">
              <p class="line" v-if="tools.isProd()">{{ item.text }}</p>

              <p class="line" v-else>
                {{ item.text + `    ${item.start}__${item.end}` }}
              </p>

              <!-- <p class="line-mask" v-if="currentLine === index">
                {{ item.text }}
              </p> -->
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="playArea">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import { computed, watchEffect, watch, reactive } from "vue";

import NotFound from "@/page/notfound.vue";

import constTags from "@/config/const.js";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import mediaUtil from "@/components/media/utils/utils.js";
import { formatDate } from "@/utils/dateTime.js";
import { $$language, $$t, $$tValue } from "@/i18n/i18n.js";
import { formatNumberRound } from "@/utils/tools";

import tools from "@/utils/tools.js";
import config, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config";
defineEmits(["close", "syncProgress"]);

const props = defineProps({
  notFound: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "",
  },
  name: {
    type: String,
    default: "",
  },
  coverUrl: {
    type: String,
    default: "",
  },
  avatar: {
    type: String,
    default: "",
  },
  lyrics: {
    type: String,
    default: "",
  },
  segments: {
    type: Array,
    default: () => [],
  },
  isFromShare: {
    type: Boolean,
    default: false,
  },
  isFromApp: {
    type: Boolean,
    default: false,
  },
  isLogin: {
    type: Boolean,
    default: false,
  },
  progress: {
    type: Number,
    default: 0,
  },
  duration: {
    type: Number,
    default: 0,
  },
  data: {
    type: Object,
    default: () => ({}),
  },
  isSelf: {
    type: Boolean,
    default: false,
  },
  isCurPlay: {
    type: Boolean,
    default: false,
  },
  isGenerating: {
    type: Boolean,
    default: false,
  },
});

const currentLine = ref(0);
const currentProgress = ref(0);
const lyricBlockRef = ref();
const lastScrollTime = ref(0);

const editTypeMap = {
  // 1 song 2-延长  3-编辑  5 翻唱 6 分轨, 7-bgm, 8-翻译
  // 1: $$t("editor.song"),
  2: $$t("editor.extend_editing"),
  3: $$t("editor.region_editing"),
  5: $$t("editor.cover_voice"),
  6: $$t("editor.track_stem"),
  // 7: $$t("editor.bgm"),
  8: $$t("editor.lyrics_translate"),
  //9: $$t("editor.trim"),
};

const getEditorType = (item) => {
  if (item.is_trimmed) {
    return $$t("editor.trim");
  }
  return editTypeMap[item.generation_method];
};

const formattedSegments = computed(() => {
  return formatSegments(props.segments);
});

let scrollTimer = null;
const handleScroll = () => {
  lastScrollTime.value = Date.now();
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }
  scrollTimer = setTimeout(() => {
    console.log("scroll end");
    scrollToTheLine();
  }, 3020);
};

const getNextLine = () => {
  if (!props.isCurPlay) {
    return -1;
  }
  const currentTime = (props.progress * props.duration) / 100;
  const nextLine = formattedSegments.value.findIndex((item, index) => {
    if (
      item.start !== undefined &&
      item.end !== undefined &&
      item.start != item.end &&
      currentTime >= item.start &&
      currentTime <= item.end &&
      item.type == "lyric"
    ) {
      return true;
    }
    return false;
  });
  return nextLine;
};

const scrollToTheLine = () => {
  const lyricBlock = lyricBlockRef.value;
  if (!lyricBlock) return;
  const nextLine = getNextLine();
  currentProgress.value = 0;
  currentLine.value = nextLine;
  const line = lyricBlock.querySelectorAll(".line");
  if (line[currentLine.value]) {
    if (Date.now() - lastScrollTime.value < 3000) {
      // console.log("scroll too fast", Date.now() - lastScrollTime.value);
      return;
    }
    line[currentLine.value].scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
    line.forEach((item) => {
      item.classList.remove("active");
    });
    line[currentLine.value].classList.add("active");
  }
  // TODO: 模拟每5%滚动一行，然后已5%为单位进行歌词进度滚动
  // currentProgress.value = ((props.progress % 5) / 5) * 100;
  // gsap.to(lyricBlock.querySelector(".line-mask"), {
  //   clipPath: `inset(0 ${100 - currentProgress.value}% 0 0)`,
  //   duration: 0.3,
  // });
};

watchEffect(() => {
  scrollToTheLine();
});

const combineStrings = (str1, str2) => {
  // if (![1, 3].includes(props.data?.publish_state)) {
    if (!(Array.isArray(str1) && Array.isArray(str2))) return;
    if (str1 && str2) {
      return `${str1.join(" ")} | ${str2.join(" ")}`;
    }
    return str1?.join(" ") || str2?.join(" ");
  // } else {
  //   // str1 =>genres str2 => moods
  //   const genres = constTags.getRenderLabel(str1, constTags.StyleLabelData.map);
  //   const moods = constTags.getRenderLabel(
  //     str2,
  //     constTags.EmotionalLabelData.map
  //   );
  //   if (genres?.length && moods?.length) {
  //     return `${genres.join(" ")} | ${moods.join(" ")}`;
  //   } else if (genres?.length) {
  //     return genres.join(" ");
  //   } else if (moods?.length) {
  //     return moods.join(" ");
  //   } else {
  //     return "";
  //   }
  // }
};

const formatLyrics = (text) => {
  return (
    text?.split("\n").map((item) => {
      return {
        type: "lyric",
        text: item,
      };
    }) ?? []
  );
};
const formatSegments = (text) => {
  return text.reduce((res, itemp) => {
    if (itemp.user_input_tag) {
      res.push({
        id: tools.getUuid(),
        type: "lyric_seg",
        seg_type: itemp.seg_type,
        text: itemp.user_input_tag,
        start: itemp.start,
        end: itemp.end,
      });
    }
    return (itemp.rows ?? []).reduce((res, item) => {
      item &&
        res.push({
          id: tools.getUuid(),
          type: "lyric",
          seg_type: itemp.seg_type,
          text: item.text,
          start: item.start,
          end: item.end,
        });
      return res;
    }, res);
  }, []);
};

watch(
  () => props.progress,
  () => {
    scrollToTheLine();
  }
);
</script>

<style lang="scss" scoped>
.detailWrapper {
  height: 100%;
  position: relative;
  padding: 8px 10px;
  color: #fff;
  .closeBtn {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      display: block;
      width: 24px;
      height: 24px;
      background: url("@/assets/img/player/close-m.svg") no-repeat center;
      background-size: 100% 100%;
    }
  }
  .musicInfo {
    height: calc(
      100% - 168px - env(safe-area-inset-bottom) - env(safe-area-inset-top)
    );
    .logo {
      height: 36px;
      margin-bottom: 28px;
    }
    .cover-img {
      width: 100px;
      height: 100px;
      border-radius: 16px;
      margin-bottom: 20px;
    }
    .title-status-info {
      display: flex;
      align-items: center;
    }
    .title {
      font-size: 24px;
      font-weight: 500;
      line-height: 24px;
      user-select: text;
      flex: 0 1 1;
    }
    .musicInfo-status {
      margin: 0 0 0 10px;
      display: flex;
      align-items: center;

      .musicInfo-publish-status {
        cursor: pointer;
        width: max-content;
        position: relative;
        margin: 0 4px 0 0;

        .musicInfo-publish-status-border {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          border-radius: 2px;
          padding: 1px;
          background: rgba(255, 255, 255, 0.5);
          mask: linear-gradient(#fff 0 0) content-box,
            linear-gradient(#fff 0 0) border-box;
          mask-composite: exclude;
        }

        .musicInfo-publish-status-text {
          font-family: HarmonyOS Sans SC;
          font-size: 10px;
          font-weight: normal;
          line-height: 18px;
          text-align: center;
          background: rgba(255, 255, 255, 0.5);
          background-clip: text;
          padding: 0 5px;
          color: transparent;
        }
      }
      .publish-icon {
        min-width: 52px;
        width: 52px;
        display: none;
      }
      .musicInfo-model-status,
      .musicInfo-edit-type-status,
      .musicInfo-edit-upload-status {
        height: 18px;
        font-family: HarmonyOS Sans SC;
        font-size: 10px;
        font-weight: normal;
        line-height: 16px;
        text-align: center;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 2px;
        padding: 0 4px;
        color: rgba(255, 255, 255, 0.5);
        margin: 0 4px 0 0;
      }
      .musicInfo-model-status {
        background: linear-gradient(
          122deg,
          #000000 10%,
          rgba(104, 31, 159, 0.7) 50%,
          #000000 89%
        );
        border: 1px solid rgba(165, 70, 220, 0.8);
        color: #fac9ff;
        backdrop-filter: blur(12px);
        opacity: 1;
        padding: 0 5px;
        font-size: 11px;
        &.O1 {
          background: linear-gradient(
            122deg,
            #000000 8%,
            #6a6112 47%,
            #000000 91%
          ) !important;
          border: 1px solid rgba(255, 241, 114, 0.8) !important;
          color: #fffc35;
          backdrop-filter: blur(12px);
        }
      }
    }

    .tag {
      text-transform: capitalize;
      margin: 12px 0 12px 0;
      font-size: 12px;
      font-weight: normal;
      line-height: normal;
      opacity: 0.8;
    }
    .rotate-loading {
      width: 16px;
      height: 16px;
      background: url("@/assets/img/loading-mini-white-3x.png");
      background-size: 100% 100%;
      display: inline-block;
    }
    .author {
      align-items: center;
      .avatar {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 8px;
        vertical-align: middle;
      }
      .avatarName {
        color: #ffffff;
        opacity: 0.8;
      }
      font-size: 12px;
      font-weight: normal;
      line-height: normal;
    }
    .gen-date {
      margin: 12px 0 20px 0;
      opacity: 0.8;
      font-size: 12px;
      line-height: 12px;
    }
    .play-count {
      height: 16px;
      width: 16px;
      margin: 0 4px 0 0px;
      background: url("@/assets/img/store/listen.png");
      background-size: 100% 100%;
      opacity: 0.75;
    }
    .lyricBlock {
      position: relative;
      z-index: 1;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      height: calc(100% - 101px - 40px - 44.5px - 60.5px);
      user-select: text;
      -webkit-mask-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 1) 90%,
        rgba(0, 0, 0, 0.3) 95%,
        rgba(0, 0, 0, 0) 100%
      );
      mask-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 1) 80%,
        rgba(0, 0, 0, 0.3) 95%,
        rgba(0, 0, 0, 0) 100%
      );

      .lyrics {
        scroll-padding-top: 102px;
      }

      .line-wrapper {
        position: relative;

        .line-mask {
          position: absolute;
          top: 0;
          left: 0;
          clip-path: inset(0 100% 0 0);
        }
      }

      .line {
        margin-bottom: 14px;
        color: #ffffff;
        &.lyric_seg--mobile:not(:first-child) {
          margin-top: 32px;
        }
        &.active {
          font-size: 18px;
          font-weight: 500;
          line-height: 24px;
          color: #94adff;
        }
      }
    }
  }
  .playArea {
    margin-top: 24px;
    width: 100%;
    height: 155px;
  }

  &.fromApp {
    padding-top: 46px;
    .playArea {
      height: 150px;
    }
    .musicInfo {
      height: calc(
        100% - 170px - env(safe-area-inset-bottom) - env(safe-area-inset-top)
      );
    }
  }
}
@media (max-height: 667px) {
  .detailWrapper {
    .musicInfo {
      .lyricBlock {
        .lyrics {
          scroll-padding-top: 2px;
        }
      }
    }
  }
}
</style>
